"use client"

import { ClerkProvider } from "@clerk/nextjs"

import { PublicFooter } from "@/components/public-footer"
import { PublicNavigation } from "@/components/public-navigation"


export default function ProtectedLayout({ children }: { children: React.ReactNode }) {
  return (
    <ClerkProvider
      appearance={{
        elements: {
          formButtonPrimary: "bg-[#8E82FF] hover:bg-[#7A6EE6]",
          footer: "hidden",
        },
      }}
      telemetry={false}
      supportEmail="support@thehiitpit.com"
    >
      <PublicNavigation />
      {children}
      <PublicFooter />
    </ClerkProvider>
  )
}
